import { render, staticRenderFns } from "./ValidTextarea.vue?vue&type=template&id=063da425&scoped=true&"
import script from "./ValidTextarea.vue?vue&type=script&lang=js&"
export * from "./ValidTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063da425",
  null
  
)

export default component.exports